const Badge = {
  baseStyle: {
    padding: "5px 10px",
    textTransform: "none",
    lineHeight: "16px",
    borderRadius: "30px",
    fontWeight: 600,
    fontSize: "12px",
  },
};

export default Badge;
